import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AccomplishmentService {
    accomplishmentRelations = '&relations=accomplishment_treatments.forest_treatment,additional_reports';

    constructor(private readonly httpClient: HttpClient) { }

    getAccomplishment(accomplishment_id: number, accomplishmentRelations: string): Observable<any> {
        let params = new HttpParams();
        let queryParams = `?accomplishment_id=${accomplishment_id}`;
        return this.httpClient.get(
            `${environment.apiUrl}/accomplishment${queryParams}${accomplishmentRelations}`, { params: params }
        );
    }

    getAccomplishmentTreatment(relations: string): Observable<any> {
      let params = new HttpParams().set('relations', relations);
      return this.httpClient.get(
        `${environment.apiUrl}/accomplishment-treatment`, { params }
      );
    }

    getAccomplishmentsByAssessmentID(assessment_id: number): Observable<any> {
        let params = new HttpParams();
        let queryParams = `?assessment_id=${assessment_id}`;
        let relations = '&relations=assessment,accomplishment_treatments.forest_treatment.treatment_specifications';
        return this.httpClient.get(
            `${environment.apiUrl}/accomplishment${queryParams}${relations}`, { params: params }
        );
    }

    createAccomplishment(assessment_id: any): Observable<any> {
        let data = {
            assessment_id: assessment_id
        };
        let params = new HttpParams()
        return this.httpClient.post(
            `${environment.apiUrl}/accomplishment`, data, { params: params }
        );
    }

    updateAccomplishment(data: {
        accomplishment_id: number,
        agreement_id?: number,
        assessment_id?: number,
        contract_id?: number,
        contract_status_id?: number,
        date_contained?: string,
        h_code?: string,
        success_failure?: string,
        recommendations?: string,
        plans?: string;
        page_1_status_id?: number,
        page_2_status_id?: number,
        page_3_status_id?: number,
        prepared_address?: string,
        prepared_name?: string,
        prepared_number?: string,
        report_name?: string,
        report_type?: string,
        submitted?: boolean,
        submitted_by?: string,
        submitted_on?: string,
    }): Observable<any> {
        let params = new HttpParams()
        return this.httpClient.put(
            `${environment.apiUrl}/accomplishment`, data, { params: params }
        );
    }

    createAccomplishmentTreatment(data: {
        accomplishment_id: number,
        forest_treatment_id: number,
        method_id?: number,
        units?: number,
        date_completed?: string,
        status_statement?: string,
        contract_id?: string,
        agreement?: string,
        contract_status_id?: number
    }): Observable<any> {
        let params = new HttpParams()
        return this.httpClient.post(
            `${environment.apiUrl}/accomplishment-treatment`, data, { params: params }
        );
    }

    updateAccomplishmentTreatment(data: {
        accomplishment_treatment_id: number,
        method_id?: number,
        units?: number,
        date_completed?: string,
        status_statement?: string,
        contract_id?: string,
        agreement?: string,
        contract_status_id?: number
    }): Observable<any> {
        let params = new HttpParams()
        return this.httpClient.put(
            `${environment.apiUrl}/accomplishment-treatment`, data, { params: params }
        );
    }

    createAccomplishmentAdditional(accomplishment_id: any): Observable<any> {
        let data = {
            accomplishment_id: accomplishment_id
        };
        let params = new HttpParams()
        return this.httpClient.post(
            `${environment.apiUrl}/additional-report`, data, { params: params }
        );
    }

    updateAccomplishmentAdditional(data: {
        additional_report_id: number,
        name?: string,
        link?: string,
    }): Observable<any> {
        let params = new HttpParams()
        return this.httpClient.put(
            `${environment.apiUrl}/additional-report`, data, { params: params }
        );
    }

    deleteAccomplishmentAdditional(additional_report_id: number) {
        let additional_report_id_list: number[] = [additional_report_id];
        let body = {additional_report_id_list}
        return this.httpClient.delete(
            `${environment.apiUrl}/additional-report`, { body: body },
        );
  }
}
